import styled from 'styled-components';
import { Typ20 } from 'dc/Typ';
import Ico16 from 'dc/Ico16';

type WrapperProps = {
  color: string;
  isCompleted: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  width: 110px;
  height: 122px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  position: relative;
  background: ${props =>
    props.isCompleted ? `${props.color}60` : props.color};
  display: flex;
  overflow: hidden;
  cursor: pointer;
`;

export const Button = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #007079;
  padding: 5px 8px;
  cursor: pointer;
`;

export const ButtonText = styled(Typ20)`
  color: #fff;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  display: inline-block;
`;

type ImageProps = {
  hasExtraBottomMargin?: boolean;
  isCompleted: boolean;
};

export const Image = styled.img<ImageProps>`
  margin-bottom: ${props => (props.hasExtraBottomMargin ? '36px' : '19px')};
  max-width: 70%;
  max-height: 70%;
  opacity: ${props => (props.isCompleted ? '0.8' : 1)};
`;

type KnowledgeWrapperProps = {
  color: string;
};

export const KnowledgeWrapper = styled.div<KnowledgeWrapperProps>`
  width: 32px;
  height: 32px;
  border-radius: 0px 0px 0px 40px;
  background: ${props => props.color};
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
`;

export const KnowledgeIcon = styled(Ico16)`
  position: absolute;
  padding: 5px 6px 11px 10px;
  cursor: pointer;
`;
